export enum Status {
   active='active',
   inactive='inactive',
   deleted='deleted'
}
